export function calcReadingTime(mdxBody: string): number {
  const text = mdxBody.match(/mdx\("p", null, "(.+)"/g)?.map(match => match.replace('mdx("p", null, "', ''))
  const wordCount = text ? text.reduce((prev, curr) => prev + curr.split(' ').length, 0) : 0

  console.log('wordCOuntr', wordCount);

  return Math.ceil((wordCount / 130));
}